import { makeStyles, tokens } from '@fluentui/react-components';

const cardWith = '306px';
const cardHeight = '224px';
const footerHeight = '32px';

export const useStyles = makeStyles({
  card: {
    boxSizing: 'border-box',
    padding: tokens.spacingVerticalXL,
  },
  body: {
    height: cardHeight,
    width: cardWith,
  },
  footer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    paddingTop: tokens.spacingVerticalXS,
    gap: tokens.spacingHorizontalS,
    height: footerHeight,
  },
  iconContainer: {
    width: tokens.fontSizeBase600,
    height: tokens.fontSizeBase600,
  },
  icon: {
    '& > svg': {
      width: tokens.fontSizeBase400,
      height: tokens.fontSizeBase400,
    },
  },
});
